/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamAuthorDropdown200,
  GetApiV1ExamAuthorDropdown400,
  GetApiV1ExamAuthorDropdown401,
  GetApiV1ExamAuthorDropdown500,
  GetApiV1ExamAuthorDropdownQueryParams,
  GetApiV1ExamAuthorDropdownQueryResponse,
} from "../../types/examSharedController/GetApiV1ExamAuthorDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1ExamAuthorDropdownQueryParamsSchema = z
  .object({
    filter: z.optional(z.string()),
    companyId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ExamAuthorDropdownQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamAuthorDropdown200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1ExamAuthorDropdown200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamAuthorDropdown400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamAuthorDropdown400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamAuthorDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamAuthorDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamAuthorDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamAuthorDropdown500>;

export const getApiV1ExamAuthorDropdownQueryResponseSchema = z.lazy(
  () => getApiV1ExamAuthorDropdown200Schema,
) as unknown as ToZod<GetApiV1ExamAuthorDropdownQueryResponse>;
